module.exports = __webpack_public_path__ + "img/logo_02.6b035021.png";